<div class="p-mt-4 p-mb-4">
  <div #chartContainer style="width: 100%; height: 300px"></div>
</div>
